import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../../shared/services/language.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { GCMService } from '../../../shared/services/gcm.service';


@Component({
  standalone: false,
  selector: 'app-edit-value-dialog',
  templateUrl: './edit-value-dialog.component.html',
  styleUrls: ['./edit-value-dialog.component.css']
})
export class EditValueDialogComponent implements OnInit {

  variables: any;
  local_data: any;
  invalidInput: boolean = false;

  errorMessage = "";
  formGroup: any;
  validForm: boolean = true;

  itemName: any;
  itemRisk: any;
  title: any;
  catalogOriginalValue: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditValueDialogComponent>,
    private languageService: LanguageService,
    private _formBuilder: FormBuilder
  ) {
    this.local_data = { data };
  }


  ngOnInit() {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });

    this.formGroup = this._formBuilder.group({
      //riskCtrl: [this.local_data.data.tech, Validators.required],
      riskCtrl: new FormControl(this.data.itemRisk.toFixed(2), [Validators.required, Validators.pattern("^[0-9]*$")]),
      nameCtrl: [this.data.itemName],
    });

    this.title = this.local_data.data.title;
    this.itemName = this.data.itemName;
    this.itemRisk = this.data.itemRisk;
    this.catalogOriginalValue = this.data.catalogOriginalValue;
  }

  onInputChange(event: any) {
    const inputValue = event.target.value;
    if (!/^\d*$/.test(inputValue)) {
      this.invalidInput = true;
    } else {
      this.invalidInput = false;
    }
  }


  doAction() {
    const itemName = this.data.itemName;
    const itemRisk = this.formGroup.get('riskCtrl').value;
    const itemFinal = {
      itemName,
      itemRisk
    }

    if (itemRisk && itemRisk > 0) {
      this.dialogRef.close(itemFinal);
    } else {
      this.onCheckError(itemRisk);
    }

  }

  onCheckError(itemRisk: any) {
    if (!itemRisk || itemRisk < 0) {
      this.invalidInput = true;
      this.errorMessage = this.variables.cannotBeNullOrLessZero;
    }
  }

}
